import GeaExplorerLangs from './GeaExplorerLangs'
import GeaExplorerTypeLangs from './GeaExplorerTypeLangs'
export const xlsxLangList = [GeaExplorerLangs,GeaExplorerTypeLangs]
